export default __webpack_public_path__ + "static/media/manual3.0c37ec55.png";